import axios from "axios";
import * as XLSX from "xlsx";

export const excelDownload = (response: any) => {
  const contentDisposition = response.headers["content-disposition"];
  let filename = "";

  if (contentDisposition) {
    const matches = contentDisposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    );
    if (matches && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }

  const arrayBuffer = response.data;
  const workbook = XLSX.read(arrayBuffer, { type: "array" });

  const outputFile = filename;
  XLSX.writeFile(workbook, outputFile);
};

export const postDownload = async (response: any) => {
  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const contentDisposition = response.headers["content-disposition"];
  let filename = "";

  if (contentDisposition) {
    const matches = contentDisposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    );
    if (matches && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }

  const workbook = XLSX.read(await blob.arrayBuffer(), { type: "array" });

  XLSX.writeFile(workbook, filename);
};
export const download = async (endpointUrl: string) => {
  const token = localStorage.getItem("dm_access_token");
  axios
    .get(endpointUrl, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "blob",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      excelDownload(response);
    });
};

export const downloadExportData = async (
  endpointUrl: string,
  chargerValue: string,
  checked: any,
  connectors: any,
  connectorType: any,
  qrFlag: any,
  filterStatus: any,
  filterTenant: any,
  filterModel: any,
  filterOcpp: any,
  selectedRows: any,
  failedWindow: any,
  setFailedWindow: any,
  successWindow: any,
  setSuccessWindow: any,
  status?: any
) => {
  const token = localStorage.getItem("dm_access_token");
  const rows = Array.isArray(selectedRows) ? selectedRows : [];
  const isRowObjects =
    rows.length > 0 &&
    rows[0] != null &&
    typeof rows[0] === "object" &&
    "chargerId" in rows[0];
  const chargersArr =
    rows.length > 0
      ? (isRowObjects ? rows.map((item: any) => item?.chargerId) : [...rows]).filter(Boolean)
      : [];
  const hasChargers = chargersArr.length > 0;
  const queryParts: string[] = [];
  if (hasChargers) queryParts.push(`Chargers=${chargersArr.join(",")}`);
  if (chargerValue !== "") queryParts.push(`Keyword=${encodeURIComponent(chargerValue)}`);
  const checkedArr = Array.isArray(checked) ? checked : [];
  if (checkedArr.length > 0) queryParts.push(`Filters.Vendors=${checkedArr.join(",")}`);
  if (filterModel !== "") queryParts.push(`Filters.Model=${encodeURIComponent(filterModel)}`);
  if (filterOcpp !== "") queryParts.push(`Filters.OCPPVersion=${encodeURIComponent(filterOcpp)}`);
  const connectorsArr = Array.isArray(connectors) ? connectors : [];
  if (connectorsArr.length > 0) queryParts.push(`Filters.NoOfConnectors=${connectorsArr.join(",")}`);
  const connectorTypeArr = Array.isArray(connectorType) ? connectorType : [];
  if (connectorTypeArr.length > 0) queryParts.push(`Filters.ConnectorType=${connectorTypeArr.join(",")}`);
  if (filterStatus?.length > 0 || status) {
    const statusVal = status ?? filterStatus;
    const statusStr = Array.isArray(statusVal) ? statusVal.join(",") : String(statusVal ?? "");
    if (statusStr) queryParts.push(`Filters.Status=${encodeURIComponent(statusStr)}`);
  }
  if (qrFlag !== "") queryParts.push(`Filters.QRCode=${encodeURIComponent(qrFlag)}`);
  if (filterTenant !== "") queryParts.push(`Filters.Tenant=${encodeURIComponent(filterTenant)}`);
  const filterExportUrl =
    endpointUrl + (queryParts.length > 0 ? queryParts.join("&") : "");

  axios
    .get(filterExportUrl, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "blob",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      excelDownload(response);
      setSuccessWindow({
        ...successWindow,
        status: true,
        message: "Downloaded successfully!!",
      });
    })
    .catch((e: any) => {
      const statusCode = e?.response?.status;
      const msg = e?.response?.data?.Message ?? e?.response?.data?.message;
      setFailedWindow({
        ...failedWindow,
        status: true,
        message:
          statusCode === 404
            ? msg || "No records found to export."
            : msg || "Export failed. Please try again.",
      });
    });
};
